import "./App.css";
import wave from "./assets/images/wave.png";
import logo from "./assets/images/logo.png";
import earth from "./assets/images/earth.png";
import controller from "./assets/images/controller.png";
import earthcontroller from "./assets/images/earth_controller.png";
import Footer from "./components/Footer";

import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import Gallery from "./components/Gallery";
import Br from "./components/Br";


function App() {
    return (
        <div className="App">
            <header>
                <img src={logo} className="logo" />
                <img src={wave} className="wave" />
                
                <div class="row">
                  <h1 className="text">Game Development Company From <span className="text-earth">Earth!</span></h1>
                  <div class="right">
                    <img src={earthcontroller} className="earthcontroller" />
                    {/* <img src={controller} className="earth" /> */}
                  </div>
                </div>
            </header>

            <div className="games">
              <h1 className="games-label">Our Games</h1>
              <Br />
              <Gallery />
              <br/>
              <br/>
              <br/>
            </div>

            <Footer />
        </div>
    );
}

export default App;
